export default "__VITE_ASSET__DMEfl5rY__"